<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Vendors</h1>
      <div class="title-right float-right">

      </div>
   </div>-->
      <div class="new-rfq">

      <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="showFilters=!showFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>


                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search"  @submit.prevent="getVendors()">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="getVendors"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterForm.search_filter" type="text" class="form-control"
                                            placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">

                                     <button type="button" class="btn create-btn" data-toggle="modal" data-target="#vendorAddModal">
                                        Create Vendor
                                    </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-row" v-if="showFilters">
                    <div class="form-group">
                            <!--<v-select multiple  placeholder="Bags" label="bag_name" @input="getVendors" v-model="filterForm.bag_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                    <template slot="no-options">
                                    Search
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.bag_name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.bag_name }}
                                    </div>
                                    </template>
                            </v-select>-->

                        <v-select multiple  placeholder="Bags" label="bag_name" v-model="selectedVendorBags" :filterable="false" :options="options" @search="onSearch">
                            <template slot="no-options">
                                Search
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.bag_name }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.bag_name }}
                                </div>
                            </template>
                        </v-select>


                    </div>
                    <div class="form-group">
                         <v-select multiple  placeholder="Country" label="name" @input="getVendors" v-model="filterForm.country_id" :filterable="false" :options="optionsCountry" :reduce="(option) => option.id" @search="onSearchCountry">
                                    <template slot="no-options">
                                    Search
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.name }}
                                    </div>
                                    </template>
                            </v-select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" @change="getVendors" v-model="filterForm.status_filter">
                            <option value="" >All</option>
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                    </div>
                    <div class="search-btnsec dl-flex">

                        <button class="btn btn-reset" type="reset" @click="resetFilter"><i class="ri-refresh-line"></i>
                        </button>
                    </div>
                </div>

            </fieldset>

            <!-- The Modal -->
<div class="modal fade " id="importModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header bg-soft-info">
        <h5 class="modal-title">Import Vendors</h5>
        <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
      </div>

        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="alert alert-success succ_msg" v-if="successMessage !=null">
            <strong class="success_msg">{{successMessage}}</strong>
        </div>
      <!-- Modal body -->
        <form @submit.prevent="importFromCsv" enctype="multipart/form-data" id="importForm" name="importForm" method="post">
          <div class="modal-body">

                <div class="form-body">
                    <div class="form-group">
                      <label class="label-control" >File *</label>
                        <div class="file-upload">
                            <div  class="file-select">
                                <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file"   accept=".csv"  class="form-control">
                            </div>
                        </div>
                    </div>
               </div>
               <div class="form-group">
                  <label class="label-control" >Sample CSV</label>
                  <div class="add-file-col">
                      <a href="admin/vendor_sample.csv" download="">Download Sample.csv</a>
                  </div>
                </div>

                <div class="mt-3">
            <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary w-sm" id="import_btn">Import</button>
          </div>
          </div>

      <!-- Modal footer -->

        </form>
    </div>
  </div>
</div>
        <div class="row">

            <div class="col-lg-12 col-md-12">
                <div class="card panel">
                    <div class="card-header headnbtn">
                        <div class="d-flex align-items-center justify-content-between">
                            <h5 class="card-title mb-0 flex-grow-1">List of Vendor</h5>
                            <div class="flex-shrink-0">
                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#importModal">
                                    <i class="fas fa-file-import"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body p-0">
                        <div class="table-responsive product-create mb-0">

                            <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Company Name</th>
                                    <th>Company Address</th>
                                    <th>Contact Name</th>
                                    <th style="width: 120px"> Details</th>
                                    <!-- <th>Added By</th> -->
                                    <th>Status</th>
                                    <th style="width: 100px">Action </th>

                                </tr>
                            </thead>
                            <template v-for="(customer, index) in vendorData.vendors.data">
                                <tr :id="customer.id">
                                    <td>{{ getSLNo(index)}}</td>
                                    <td><router-link
                                         :to="{name: 'vendorDetails', params: {id: customer.id}}"
                                          title="Details Customer" :data-id="customer.id">{{customer.company_name}}</router-link></td>
                                    <td>{{customer.country ? customer.country.name : '' }}</td>
                                    <td>{{customer.contacts[0] ? customer.contacts[0].contact_name : '' }}</td>
                                    <td> <router-link v-if="vendorData.can_edit_vendor"
                                                 :to="{name: 'vendorDetails', params: {id: customer.id}}"
                                                 class="btn view-btn" title="Details Customer" :data-id="customer.id">
                                                 <i class="ri-eye-line"></i></router-link></td>

                                    <!-- <td>{{formatDate(customer.created_at)}}</td>-->
                                    <!-- <td><template v-if="customer.added_data != null">{{customer.added_data.name}}</template></td>  -->
                                    <td><a href="#" :class="[customer.status=='1' ? 'btn active-btn':'btn inactive-btn']" >{{(customer.status=='1')?'Active':'Inactive'}}</a></td>
                                    <td>
                                        <router-link
                                                 :to="{name: 'editVendor', params: {id: customer.id}}"
                                                 class="edit_btn" title="Edit Vendor" :data-id="customer.id"><i class="ri-edit-fill me-1"></i></router-link>
                                        <a v-if="vendorData.can_delete_vendor" href="javascript:void(0);" @click="showDelete(customer.id)" class="del_btn" title="Delete Customer" :data-id="customer.id"><i class="ri-delete-bin-6-line"></i></a>
                                    </td>
                                </tr>
                            </template>
                            </table>
                        </div>

                    </div>

                    <div class="btnrow text-left mb-3">
                        <template>
                        <div class="overflow-auto">
                            <b-pagination
                            v-model="current_page"
                            :total-rows="total"
                            :per-page="per_page"
                            ></b-pagination>

                            <!-- <p class="mt-3">Current Page: {{ current_page }}</p> -->


                        </div>
                        </template>
                    </div>
                </div>


            </div>
        </div>



      </div>

      <!-- Delete Modal HTML -->
    <div id="deleteModal" class="modal fade delete-modal">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
                <div class="modal-header">

                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body text-center">
                   <div class="trashbtn"><i class="ri-delete-bin-6-line"></i></div>
                    <h4 class="inr-title">Are you sure?</h4>
                    <p>Do you really want to delete these records? This process cannot be undone.</p>

                    <div class="btnrow">
                        <button type="button" class="btn btn-primary  me-1" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-danger confirm_delete" @click="deleteVendor()">Delete</button>
                    </div>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">

            </div>
        </div>
    </div>

   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
   <VendorAddModal></VendorAddModal>
</div>

</template>

<script>
import VendorAddModal from "../../components/VendorAddModal";
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import {EventBus} from "../../event-bus";

export default {
    name: "VendorList",
    components: {
        VendorAddModal,
    },
    created() {
        window.addEventListener('beforeunload', this.beforePageUnload);
        this.current_page = 1;
        //this.getVendors();
        this.setSuccessMessage(null);

        EventBus.$on('resetVendorFilter', this.resetFilter);
    },
    beforeMount() {
        if(this.vendorFilter) {
            this.showFilters = this.vendorFilter.showFilters;
            this.filterForm = this.vendorFilter.filterForm;
            //console.log(this.vendorFilter.filterForm);
            this.filterDataAll();
           //
        }
        this.getVendors();
    },
    beforeRouteLeave (to, from , next) {
        //console.log(to)
        if(to.name == 'vendorDetails') {
            let vendorFilter = {
                showFilters: this.showFilters,
                filterForm: this.filterForm
            }
            this.setVendorFilter(vendorFilter);
        } else {
            this.filterForm = {
                search_filter: null,
                status_filter: '',
                vendor_bag: [],
                country_id: [],
                bag_id:[],
            };

            let vendorFilter = {
                showFilters: false,
                filterForm: this.filterForm
            }
            this.setVendorFilter(vendorFilter);
        }
        next();
    },
    data(){
        return {
            selectedVendorBags: [],
            showFilters: false,
            options:[],
            optionsCountry:[],
            vendorData: {
                vendors: {
                    data:[]
                },
                config: null,
                can_add_vendor: false,
                can_edit_vendor: false,
                can_delete_vendor: false,
                user_type: null,
                role: null,
                country_fil: null,
                country_data: null,
                country_detail: null,
                bag_fil: null,
                bag_detail: null,
                check_filter: null,
                data: null,
                vendorBags: null,
                countries: null,
                user: null,
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '',
                vendor_bag: [],
                country_id: [],
                bag_id:[],

            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setVendorFilter'
        ]),
        beforePageUnload() {
            this.resetFilter();
        },
        resetFilter(){
            this.filterForm = {
                search_filter: null,
                status_filter: '',
                vendor_bag: [],
                country_id: [],
                bag_id:[],
            };

            let vendorFilter = {
                showFilters: this.showFilters,
                filterForm: this.filterForm
            }
            this.setVendorFilter(vendorFilter);

            this.current_page = 1;
            this.getVendors();
        },
        vendorDataSaved(){
            $('#vendorAddModal').modal('hide');
            this.current_page = 1;
            this.getVendors();
        },

        onSearchCountry(search, loading){
            if(search.length) {
                loading(true);
                this.searchCountry(loading, search, this);
            }

        },
        searchCountry(loading, search, vm) {let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchCountry',{searchTerm: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                //console.log("DATA ",data.data);
                if(data.errors){
                    //console.log("error ",data.data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    //console.log("Length",data);

                    let allData =  data.data
                    //console.log("Length",allData,allData.length);
                    vm.optionsCountry = data.data;
                    //console.log("options ",vm.options);
                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },

        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchVendorsBag',{searchTerm: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                //console.log("DATA ",data);
                if(data.errors){
                    //console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    //console.log("Length",data);

                    let allData =  data.data.data
                    //console.log("Length",allData,allData.length);
                    vm.options = data.data.data;
                    //console.log("options ",vm.options);
                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        getVendors() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.index', {
                _query: {
                    is_draft: 0,
                    search_filter: this.filterForm.search_filter,
                    status_filter: this.filterForm.status_filter,
                    vendor_bag: this.filterForm.vendor_bag,
                    country_id: this.filterForm.country_id,
                    bag_id: this.filterForm.bag_id,
                    page: this.current_page
                }
            }), {
                //params: this.filterForm,
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {

                        this.vendorData = data.data;
                        //console.log("Vendor filterForm",this.filterForm);
                        this.current_page = data.data.vendors.current_page;
                        this.per_page = data.data.vendors.per_page;
                        this.total = data.data.vendors.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },

        filterDataAll() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
             return axios.post(window.route('vendor.getVendorFilterData' ),this.vendorFilter.filterForm, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    //console.log(data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.options = data.data.vendor_bag;
                        this.optionsCountry = data.data.country;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.vendorData.config['start_from']) + index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        importFromCsv(){
            let self = this;
            if( this.csv_file){
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                this.showUploadProgress = true;
                this.processingUpload = true;
                this.uploadPercent = 0;
                let formData = new FormData();
                formData.append('csv_file',  this.csv_file);
                axios.post(window.route('vendor.importVendor'), formData, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        this.uploadPercent = progressEvent.lengthComputable ? Math.round( (progressEvent.loaded * 100) / progressEvent.total ) : 0 ;
                    }
                })
                    .then( ({ data }) => {
                        this.showUploadProgress = false;
                        this.processingUpload = false;
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.getVendors();
                            self.setSuccessMessage(data.data);
                            $('#exportModal').modal('hide');
                        }

                    })
                    .catch( (error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                        this.showUploadProgress = false;
                        this.processingUpload = false;
                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteVendor() {
            if(this.deleteId) {
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('vendors.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.deleteId = null;
                            self.getVendors();
                            $('#deleteModal').modal('hide');
                            self.setSuccessMessage(null);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customersLoading',
            'vendorFilter'
        ])
    },
    watch: {
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getVendors();
                }
            }
        },
        showFilters: {
            handler: function (value) {
                let vendorFilter = {
                    showFilters: value,
                    filterForm: this.filterForm
                }
                this.setVendorFilter(vendorFilter);
            }
        },
        filterData: {
            handler: function (value) {
                let vendorFilter = {
                    showFilters: this.showFilters,
                    filterForm: value
                }
                this.setVendorFilter(vendorFilter);
            },
            deep: true
        },
        selectedVendorBags: {
            handler: function (newValue, oldValue) {
                //console.log(newValue)
                this.filterForm.bag_id = [];
                newValue.forEach((x) => {
                    this.filterForm.bag_id.push(x.id);
                });
                this.getVendors();
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
